import DOMPurify from "dompurify";

// Texte HTML saisi dans le configurateur (module Contact) : on garde les liens
// cliquables et la mise en forme simple, on retire tout ce qui peut exécuter du
// code (scripts, iframes, attributs on*, liens javascript:, styles…).
const ALLOWED_TAGS = [
    "a",
    "br",
    "p",
    "span",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "ul",
    "ol",
    "li",
    "h3",
    "h4",
];
const ALLOWED_ATTR = ["href", "target", "rel", "title"];

// Un lien ouvert dans un nouvel onglet ne doit pas pouvoir piloter la page d'origine.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
        node.setAttribute("rel", "noopener noreferrer");
    }
});

export const safeHtml = (html) =>
    DOMPurify.sanitize(typeof html === "string" ? html : "", {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
    });
